<template>
  <kbd class="tag" :class="[color ? color : '', large ? 'big' : '']">
    <slot></slot>
  </kbd>
</template>
<script>
export default {
  props: {
    large: {
      type: Boolean,
      default: false
    },
    color: {
      type: String,
      default: null
    }
  }
};
</script>
